import { render } from "./EditSimCard.vue?vue&type=template&id=70c76d43"
import script from "./EditSimCard.vue?vue&type=script&lang=js"
export * from "./EditSimCard.vue?vue&type=script&lang=js"
script.render = render

export default script